import dayjs from "dayjs";

export const DISABLED_FUTURE_DATE = (current?: dayjs.Dayjs) =>
  current ? current > dayjs().endOf("day") : false;
